import React, { useEffect, useRef, useState } from 'react'
import { select } from 'd3'
import cloud from 'd3-cloud'
import { CircularLoader } from '@st-operations/uikit/src/v2/index'

import './styles.scss'

const COLORS = [
  '#13682B',
  '#5BAC4D',
  '#91D400',
  '#F7DB71',
  '#34158C',
  '#A40965',
  '#8C3A6D',
  '#146A59',
  '#0CB2B2',
  '#7DE2D3',
  '#FF2710',
  '#10441B',
]

const getRandomColor = () => {
  return COLORS[Math.floor(Math.random() * COLORS.length)]
}

const WordCloud = ({ data, onWordClick, isLoading }) => {
  const containerRef = useRef()
  const biggest = Math.max(...data.map(({ size }) => size))
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const containerSize = containerRef.current.getBoundingClientRect()

    const layout = cloud()
      .size([containerSize.width, containerSize.height])
      .words(
        data.map((word) => {
          const min = 1
          const max = 90
          const size = (word.size / biggest) * (max - min) + min
          return { ...word, size }
        })
      )
      .rotate(() => 0)
      .font('Open Sans')
      .fontSize((word) => word.size)
      .on('end', draw)

    layout.start()

    function draw(words) {
      const container = select(containerRef.current)
      const svg = document.querySelector('#keywordsCloud')
      let element = null
      if (svg) {
        element = select(svg).html('')
      } else {
        element = container.append('svg').attr('id', 'keywordsCloud')
      }

      element
        .attr('width', layout.size()[0])
        .attr('height', layout.size()[1])
        .attr('viewBox', '0 0 ' + layout.size()[0] + ' ' + layout.size()[1])
        .style('width', '100%')
        .style('height', 'auto')
        .append('g')
        .attr('transform', 'translate(' + layout.size()[0] / 2 + ',' + layout.size()[1] / 2 + ')')
        .selectAll('text')
        .data(words)
        .enter()
        .append('text')
        .style('fill', getRandomColor)
        .classed('de-wordcloud__word', true)
        .on('click', (event) => {
          onWordClick(event.srcElement.__data__)
        })
        .attr('text-anchor', 'middle')
        .attr('transform', (word) => `translate(${[word.x, word.y]})`)
        .text((word) => word.text)
        .style('font-family', 'Open Sans')
        .style('font-size', (word) => {
          setLoading(false)
          return word.size + 'px'
        })
        .style('cursor', 'pointer')
    }
  }, [data])

  return (
    <div ref={containerRef} className="de-wordcloud">
      <If condition={loading || isLoading}>
        <div className="de-wordcloud__loader">
          <CircularLoader />
        </div>
      </If>
      <If condition={!(loading || isLoading) && data.length === 0}>
        <p>{"There's no data available"}</p>
      </If>
    </div>
  )
}

export default React.memo(WordCloud)
